import { injectGlobal } from "styled-components";
import { BTTO_PROFILE_COLORS } from "./elements";

let injected = false;

const injectOnce = () => {
	if (injected) return;
	injected = true;

	injectGlobal`
	.ant-picker-dropdown,
	.bt-betto-history-modal,
	.bt-betto-profile-content {
		--header-color: ${BTTO_PROFILE_COLORS.primary};
		--border-color: ${BTTO_PROFILE_COLORS.primary};
		--secondary-border-color: rgba(3, 98, 212, 0.18);
		--secondary-color-dark: ${BTTO_PROFILE_COLORS.primaryDark};
		--modal-bg: ${BTTO_PROFILE_COLORS.surface};
		--content-text-color: ${BTTO_PROFILE_COLORS.text};
		--main-secondary-text-color: ${BTTO_PROFILE_COLORS.textMuted};
		--input-bg-has-value: ${BTTO_PROFILE_COLORS.surfaceRaised};
		--content-body-gradient: rgba(3, 98, 212, 0.12);
		--profile-page-wrapper-bg: transparent;
	}

	.ant-picker-dropdown .ant-picker-panel-container {
		border-radius: 12px;
		border: 1px solid ${BTTO_PROFILE_COLORS.border};
		box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
		background: ${BTTO_PROFILE_COLORS.surface};
	}

	.ant-picker-dropdown .ant-picker-content th {
		color: ${BTTO_PROFILE_COLORS.textMuted};
	}

	.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
		background: rgba(3, 98, 212, 0.18);
	}

	.ant-picker-dropdown .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
	.ant-picker-dropdown .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
		background: rgba(3, 98, 212, 0.25) !important;
	}

	.ant-picker-dropdown .selected-range {
		background: rgba(3, 98, 212, 0.25) !important;
	}
`;
};

export const BettoHistoryModalGlobalStyles = () => {
	injectOnce();
	return null;
};
